import styled from '@emotion/styled';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import React, { forwardRef, Fragment, useCallback } from 'react';
import { css } from '@emotion/react';
import { TextButton, } from '@polestar/component-warehouse-react/components/button/Button';
import { DarkThemeProvider } from '@polestar/component-warehouse-react/components/theme-providers/ThemeProviders';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
const Snackbar = forwardRef(({ content, buttonLabel, buttonProps, error = false, ...props }, ref) => {
    const handleButtonKeyDown = useCallback((event) => {
        // prevent handleKeyDown to be needlessly fired
        event.stopPropagation();
    }, []);
    const clickable = (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) !== undefined;
    const ThemeWrapper = error ? DarkThemeProvider : Fragment;
    return (React.createElement(Container, { ref: ref, clickable: clickable },
        React.createElement(ThemeWrapper, null,
            React.createElement(Inner, { error: error, ...props },
                React.createElement(TextContainer, null, content),
                buttonLabel ? (React.createElement(TextButtonWrapper, { error: error },
                    React.createElement(TextButton, { ...buttonProps, icon: false, onKeyDown: handleButtonKeyDown }, buttonLabel))) : null))));
});
Snackbar.displayName = 'Snackbar';
export default Snackbar;
const TextButtonWrapper = styled.div `
  margin-inline-start: auto;
  display: flex;
  align-items: flex-end;
  padding: ${Spacings.medium};
  padding-block-start: 0;
`;
const TextContainer = styled(Paragraph) `
  padding: ${Spacings.medium};
`;
const Container = styled.div(({ clickable }) => css(css `
      width: 100%;
      padding-block-start: ${Spacings.medium};
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    `, !clickable &&
    css `
        cursor: default;

        &:hover {
          cursor: default;
        }
      `));
const Inner = styled.div(({ theme, error }) => css `
    display: flex;
    background-color: ${error
    ? theme.snackbar.error.backgroundColor
    : theme.snackbar.default.backgroundColor};
  `);
